import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 16px;\n    overflow-y: auto;\n\n    ::-webkit-scrollbar {\n        display: none;\n    }\n\n    ::-webkit-scrollbar:hover {\n        display: block;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    margin: 9px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledCollapseButton = styled.div(_templateObject(), function (props) {
  return "\n        cursor: pointer;\n        font-size: ".concat(props.theme.components.sideNav.collapseButton.fontSize, ";\n        position: absolute;\n        right: 16px;\n        text-align: center;\n        top: calc(calc(").concat(props.theme.components.sideNav.logo.height, " - ").concat(props.theme.components.sideNav.collapseButton.fontSize, ") / 2);\n        transition: ").concat(props.theme.components.sideNav.transition, ";\n        width: 30px;\n        z-index: ").concat(props.theme.components.sideNav.collapseButton.zIndex, ";\n\n        ").concat(props.collapsedMenu ? "\n                    transform: rotate(180deg);\n                    right: -5px;\n                " : '', "\n    ");
});
export var StyledLogoWrapper = styled.div(_templateObject2(), function (props) {
  return "\n        height: ".concat(props.theme.components.sideNav.logo.height, ";\n        background-color: ").concat(props.theme.components.sideNav.logo.backgroundColor, ";\n    ");
});
export var StyledLogo = styled.img(_templateObject3());
export var StyledNavItemContent = styled.div(_templateObject4(), function (props) {
  return "\n        position: fixed;\n        top: 100vh;\n        left: 0;\n        right: ".concat(props.theme.components.sideNav.right, ";\n        bottom: 60px;\n        z-index: -1;\n        overflow: auto;\n\n        max-height: 100vh;\n        padding: ").concat(props.theme.components.sideNav.subNavItems.padding, ";\n        padding-top: ").concat(props.theme.components.sideNav.top, ";\n\n        background-color: ").concat(props.theme.components.sideNav.backgroundColor, ";\n        color: ").concat(props.theme.components.sideNav.subNavItems.color, ";\n\n        font-family: \"Montserrat\";\n        font-size: ").concat(props.theme.components.sideNav.fontSize, ";\n        line-height: ").concat(props.theme.components.sideNav.lineHeight, ";\n        font-weight: ").concat(props.theme.components.sideNav.fontWeight, ";\n\n        transition: ").concat(props.theme.components.sideNav.transition, ";\n\n        ").concat(props.visible ? "\n                    top: 0;\n                    z-index: ".concat(props.theme.components.sideNav.zIndex + 1, ";\n                ") : '', "\n    ");
});
export var StyledMobileSideNav = function StyledMobileSideNav(props) {
  return "\n    flex-direction: row;\n    top: unset;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden;\n\n    width: 100%;\n    height: 64px;\n    padding: 0;\n\n    background-color: ".concat(props.theme.components.sideNav.mobileColor, ";\n    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.25);\n");
};
export var StyledScrollable = styled.div(_templateObject5());
export var StyledSideNav = styled.div(_templateObject6(), function (props) {
  return "\n        display: flex;\n        flex-direction: column;\n        position: fixed;\n        box-sizing: border-box;\n        top: 0;\n        left: 0;\n        z-index: ".concat(props.theme.components.sideNav.zIndex - 1, ";\n\n        height: 100vh;\n        width: ").concat(props.width ? "".concat(props.width, "px") : props.theme.components.sideNav.defaultWidth, ";\n\n        font-family: \"Montserrat\";\n        font-size: ").concat(props.theme.components.sideNav.fontSize, ";\n        line-height: ").concat(props.theme.components.sideNav.lineHeight, ";\n        font-weight: ").concat(props.theme.components.sideNav.fontWeight, ";\n\n        background-color: ").concat(props.theme.components.sideNav.backgroundColor, ";\n        color: ").concat(props.theme.components.sideNav.color, ";\n        box-shadow: ").concat(props.shadow ? '0px 0px 10px 0px rgba(0,0,0,0.25)' : 'none', ";\n        opacity: ").concat(props.mobile !== null ? '1' : '0', ";\n        transition: ").concat(props.theme.components.sideNav.transition, ";\n\n        ").concat(props.mobile ? StyledMobileSideNav(props) : '', "\n\n        ").concat(props.collapsedMenu && !props.mobile ? "\n                    width: ".concat(props.theme.components.sideNav.collapsedWidth, ";\n                ") : '', "\n    ");
});